import { SubmissionError } from "redux-form";

export class createApiActions {
  constructor(settings) {
    // Pass in an api object with
    //settings.api =  get(query), update(id, data), merge([ids])
    this.api = settings.api;
    this.name = settings.name;
  }

  /* Returns the data to whatever component used this function */
  componentResponse(res) {
    let ids = res.data.map((r) => r.id);
    let componentData = { ids: ids, count: res.count, pages: {} };
    componentData.pages[`${res.pagination.page}`] = ids;
    componentData.currentPage = res.pagination.page;
    return componentData;
  }

  createUpdate = (data) => {
    return (dispatch) =>
      new Promise((resolve, reject) => {
        const { name, api } = this;

        if (data.id) {
          dispatch({ type: `${name}_UPDATE`, data: data });
        } else {
          dispatch({ type: `${name}_CREATE`, data: data });
        }

        return api
          .createUpdate(data)
          .then((res) => {
            dispatch({ type: `${name}_RECEIVED`, data: res.data });
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
  };

  update = (id, data) => {
    return (dispatch) => {
      const { name, api } = this;
      dispatch({ type: `${name}_UPDATE`, data: data });

      return api.update(id, data).then((res) => {
        dispatch({ type: `${name}_RECEIVED`, data: res.data });
      });
    };
  };

  get = (query = {}, errorOnEmpty = false) => {
    return (dispatch) =>
      new Promise((resolve, reject) => {
        const { api, name } = this;

        return api
          .get(query)
          .then((res) => {
            // Dispatch the data to the reducer
            dispatch({ type: `${name}_RECEIVED`, data: res.data });

            // Make the promise fail so that forms can show no result as a form of validation to continue
            if (res.data && res.data.data.length < 1 && errorOnEmpty) {
              reject(
                new SubmissionError({
                  _error: "empty",
                })
              );
            }
            resolve(res.data);
          })
          .catch((err) => {
            // Return the err to whatever component used this function

            reject(
              new SubmissionError({
                _error: err,
              })
            );
          });
      });
  };

  merge = (ids = []) => {
    return (dispatch) => {
      const { api, name } = this;

      return api.merge(ids).then((res) => {
        // Merge returns the winning Id. All the other IDs should be cleared
        // What if these records were paginated? How would they be removed from their individual pages?
        // Main store item should be marked for deletion
        // 1. Mark for deletion in the main store. If a component uses a deleted value, we should remove
        // 2. Clear from all components? Needs to be mark the record in the store as deleted.
        // [1...20] - Merge on 2 of these items, changes all responses after the merge

        // Every time we use the records, we need to check if any of them have been removed.
        // Whenever a component is instantiated, we should initiate it by pulling its data. In this way it doesn't
        // matter if a record was removed.

        // If the current record is open
        let winningRecord = res.data[0].id;
        let losingArray = ids.filter((id) => winningRecord !== id);

        // Dispatch the data to the reducer (the winning record)
        dispatch({ type: `${name}_RECEIVED`, data: res.data[0].id });

        dispatch({ type: `${name}_REMOVE`, data: losingArray });
        // Updates the winning record to include all of it's new associations

        // Remove old records, make sure that components can handle undefined key.
        const mergedIds = losingArray;

        // The component knows it's active page. We need to set the state of that page to isLoaded: false so it rehydrates.
        // We are sending back Id's of removed items.

        // Returns the data to whatever component used this function
        return mergedIds;
      });
    };
  };

  reset = () => {
    const { name } = this;
    return { type: `${name}_RESET` };
  };
}
